import React from 'react';
import { SOCIAL_SHARE, STRINGS } from '../../../constants';
import { BQLink } from '../../atoms/bqlink';
import get from 'lodash/get';
import { connect, useSelector } from 'react-redux';
import { followIconsDl } from '../../../helpers/datalayer-utils';
import GoogleBadge from '../../molecules/google-badge';
import { isMobile } from 'react-device-detect';
import './social-share.module.css';

const SocialShareHorizontal = ({
  pageType,
  sectionName,
  isTwitter = false,
  googleBadge = false,
}) => {
  const userData = useSelector((state) => get(state, ['userData']));
  return (
    <div
      styleName={googleBadge && isMobile ? 'social-share badge-section' : 'social-share'}
      className="social-share"
    >
      <div styleName="ss-horizontal" className="ss-horizontal">
        <div styleName="heading">
          <span>{STRINGS.JOIN}</span>
          <span>{STRINGS.OFFICIAL_CHANNELS}</span>
        </div>
        <nav styleName="social-icons">
          <BQLink href={SOCIAL_SHARE.WHATSAPP} target="_blank">
            <i
              className="icon-ic_whatsapp"
              onClick={() => followIconsDl('whatsapp', pageType, userData, sectionName)}
            />
          </BQLink>
          <BQLink href={SOCIAL_SHARE.TWITTER} target="_blank" aria-label="twitter">
            <i
              className={isTwitter ? 'icon-ic_twitter m-twitter' : 'icon-ic_twitter'}
              onClick={() => followIconsDl('twitter', pageType, userData, sectionName)}
            />
          </BQLink>
          <BQLink href={SOCIAL_SHARE.FACEBOOK} target="_blank">
            <i
              className="icon-ic_facebook"
              onClick={() => followIconsDl('facebook', pageType, userData, sectionName)}
            />
          </BQLink>
          <BQLink href={SOCIAL_SHARE.LINKEDIN} target="_blank">
            <i
              className="icon-ic_linkedin"
              onClick={() => followIconsDl('linkedin', pageType, userData, sectionName)}
            />
          </BQLink>
          <BQLink href={SOCIAL_SHARE.INSTAGRAM} target="_blank">
            <i
              className="icon-ic_instagram"
              onClick={() => followIconsDl('instagram', pageType, userData, sectionName)}
            />
          </BQLink>
          <BQLink href={SOCIAL_SHARE.TELEGRAM} target="_blank">
            <i
              className="icon-ic_telegram"
              onClick={() => followIconsDl('telegram', pageType, userData, sectionName)}
            />
          </BQLink>
          <BQLink href={SOCIAL_SHARE.YOUTUBE} target="_blank">
            <i
              className="icon-ic_youtube"
              onClick={() => followIconsDl('youtube', pageType, userData, sectionName)}
            />
          </BQLink>
        </nav>
        {googleBadge && isMobile && <GoogleBadge position="social-badge" />}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pageType: get(state, ['qt', 'pageType'], ''),
});

export default connect(mapStateToProps)(SocialShareHorizontal);
